import React, { useEffect, useState } from "react";
import countapi from "countapi-js";
import { generateClient } from "aws-amplify/data";

const client = generateClient();

export default function Footer({
  logo,
  description,
  bgColor = "bg-sky-400",
  textColor = "text-sky-900",
}) {
  const [quote, setQuote] = useState("");
  const [author, setAuthor] = useState("null");

  useEffect(() => {
    const fetchMensaje = async () => {
      try {
        const { data: items } = await client.models.Parametro.list({
          filter: {
            or: [{ clave: { eq: "quote" } }, { clave: { eq: "author" } }],
          },
        });

        const quoteParam = items.find((param) => param.clave === "quote");
        const authorParam = items.find((param) => param.clave === "author");

        if (quoteParam) setQuote(quoteParam.valor);
        if (authorParam) setAuthor(authorParam.valor);
      } catch (error) {
        console.error("Error al obtener el mensaje:", error);
      }
    };

    fetchMensaje();
  }, []);

  return (
    <footer className={`w-full ${bgColor} ${textColor} py-6`}>
      <div className="mx-auto flex max-w-5xl flex-col items-center justify-between px-6 lg:flex-row">
        {/* Sección Fundadora */}
        <div className="flex items-center space-x-4">
          <img
            src="qr_seguimiento.png"
            alt="Fundadora"
            className="max-h-64 min-h-32 border border-gray-600 object-cover md:max-h-36 lg:max-h-40 2xl:max-h-56"
          />
          <p className="text-md font-light text-blue-800 lg:text-lg xl:text-xl">
            Escanea o da clic
            <a
              href="https://docs.google.com/forms/d/e/1FAIpQLSc0qJqbDe4Gje_AO8CsaIw0A7idZtXSXw7uqH1lPmk-LQ1QWw/viewform?usp=sharing&ouid=117670777601368452479"
              className="px-2 font-extrabold uppercase text-blue-900 underline"
            >
              aquí
            </a>
            para el seguimiento de los libros
          </p>
          {/* {logo && (
            <img
              src={logo}
              alt="Fundadora"
              className="max-h-64 min-h-32 border border-gray-600 object-cover md:max-h-36 lg:max-h-40 2xl:max-h-56"
            />
          )} */}
          {/* {description && (
            <p className="text-md font-light text-gray-300 lg:text-lg xl:text-xl">
              {description}
            </p>
          )} */}
        </div>

        {/* Sección de la frase */}
        {quote && (
          <div className="m-4 max-w-xl rounded-2xl bg-sky-400 px-4 py-3 text-center text-sky-900 shadow-md">
            <p className="text-md font-semibold italic lg:text-lg xl:text-xl">
              “{quote}”
            </p>
            {author && (
              <p className="lg:text-md mt-2 text-sm font-light text-sky-900 xl:text-lg">
                — {author}
              </p>
            )}
          </div>
        )}
      </div>
    </footer>
  );
}
